import { DetailsProps } from './types';

const Details = ({
    id,
    containerClassName,
    titleClassName,
    className,
    title,
    inlineHelp,
}: DetailsProps) => (
    <details id={id} className={`details ${containerClassName}`}>
        <summary className='details-summary'>
            <span className={`details-summary-title ${titleClassName}`}>
                <i className='icon-chevron-right me-1' aria-hidden='true' />
                <span className='details-summary-title-text'>{title}</span>
            </span>
        </summary>
        <div className={`details-text ${className}`}>
            {inlineHelp}
        </div>
    </details>
);

export default Details;
